const addLightboxToGallery = () => {
	const galleries = document.querySelectorAll(
		'.wp-block-gallery.is-style-lightbox-gallery, .farlo-ui-marquee.is-style-masonry'
	);

	galleries.forEach(function(gallery) {
		const images = gallery.querySelectorAll('img');
		const imageArray = Array.from(images);
		const isMasonry = gallery.classList.contains('is-style-masonry');

		// Prefer the full-size image when the markup provides one
		const getSrc = (image) => image.dataset.fullSrc || image.src;

		imageArray.forEach(function(image, index) {
			image.addEventListener('click', function(event) {
				event.preventDefault();

				const lightbox = document.createElement('div');
				lightbox.classList.add('farlo-ui-lightbox', 'farlo-ui-lightbox--active');

				if (isMasonry) {
					lightbox.classList.add('farlo-ui-lightbox--masonry');
				}

				const lightboxBackdrop = document.createElement('div');
				lightboxBackdrop.classList.add('farlo-ui-lightbox__backdrop');

				const lightboxContainer = document.createElement('div');
				lightboxContainer.classList.add('farlo-ui-lightbox__inner', 'farlo-ui-lightbox__gallery');

				const img = document.createElement('img');
				img.src = getSrc(this);
				img.alt = this.alt;

				const closeButton = document.createElement('button');
				closeButton.classList.add('farlo-ui-lightbox__close');
				closeButton.setAttribute('aria-label', 'Close');
				closeButton.innerHTML = '<span></span>';

				const closeLightbox = function() {
					document.removeEventListener('keydown', onKeydown);
					document.documentElement.style.overflow = '';
					lightbox.remove();
				};

				closeButton.addEventListener('click', closeLightbox);

				const prevButton = document.createElement('button');
				prevButton.classList.add('farlo-ui-lightbox__gallery--prev');
				prevButton.setAttribute('aria-label', 'Previous image');
				prevButton.innerHTML = '<span><</span>';
				prevButton.addEventListener('click', function() {
					showImage(index - 1);
				});

				const nextButton = document.createElement('button');
				nextButton.classList.add('farlo-ui-lightbox__gallery--next');
				nextButton.setAttribute('aria-label', 'Next image');
				nextButton.innerHTML = '<span>></span>';
				nextButton.addEventListener('click', function() {
					showImage(index + 1);
				});

				lightboxBackdrop.addEventListener('click', closeLightbox);

				function showImage(newIndex) {
					if (newIndex < 0) {
						newIndex = imageArray.length - 1;
					} else if (newIndex >= imageArray.length) {
						newIndex = 0;
					}
					index = newIndex; // Update the index
					img.src = getSrc(imageArray[ newIndex ]);
					img.alt = imageArray[ newIndex ].alt;
				}

				function onKeydown(e) {
					if (e.key === 'Escape') {
						closeLightbox();
					} else if (e.key === 'ArrowLeft') {
						showImage(index - 1);
					} else if (e.key === 'ArrowRight') {
						showImage(index + 1);
					}
				}

				document.addEventListener('keydown', onKeydown);
				document.documentElement.style.overflow = 'hidden';

				lightboxContainer.appendChild(prevButton);
				lightboxContainer.appendChild(img);
				lightboxContainer.appendChild(nextButton);
				lightbox.appendChild(closeButton);
				lightbox.appendChild(lightboxBackdrop);
				lightbox.appendChild(lightboxContainer);
				document.body.appendChild(lightbox);
				closeButton.focus();
			});
		});
	});
};

export default addLightboxToGallery;
